module.exports = __webpack_public_path__ + "img/nlic_gallery10.dbe26c5a.jpg";